import { Outlet, createFileRoute, useParams } from '@tanstack/react-router';
import { VStack } from '@/components/Layout';
import { CertificationKind } from '@/routes/_staff/certification/-constants';
import { CertificationProfileHeader } from '../../-components/CertificationProfileHeader';
import { useGetPersonBaseCertificationHeader } from '../../-queries';
export const Route = createFileRoute('/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout')({
  component: RouteComponent
});
function RouteComponent() {
  const {
    id,
    personCertificationInformationId
  } = useParams({
    from: '/_staff/person/$id/certifications/base-certifications/$personCertificationInformationId/_layout'
  });
  const {
    data
  } = useGetPersonBaseCertificationHeader(id, personCertificationInformationId);
  return <VStack className="gap-0">
      <CertificationProfileHeader personId={id} personCertificationInformationId={personCertificationInformationId} certificationName={data.personBaseCertification.certificationName} certificationNumber={data.personBaseCertification.certificationNumber} certificationStatus={data.personBaseCertification.certificationStatus} certificationKind={CertificationKind.BASE} certificationHolder={{
      name: data.personBaseCertification.certificationHolder.name,
      avatarUrl: data.personBaseCertification.certificationHolder.avatarUrl ?? undefined
    }} />
      <Outlet />
    </VStack>;
}